import { render, staticRenderFns } from "./SettingsPatientUsersBottomPanelLeft.vue?vue&type=template&id=1b78066a"
import script from "./SettingsPatientUsersBottomPanelLeft.vue?vue&type=script&lang=js"
export * from "./SettingsPatientUsersBottomPanelLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports